<template>
  <div class="card shadow historique">
    <CommonHeader :page="'Paiements'" />
    <div style="margin:25px;">
      <b-button v-b-modal.modal-1>Exporter des données</b-button>

      <b-modal id="modal-1" title="Export" :hide-footer="true" ref="modalExcel">
        <div
          style="position:relative;width:100%;height:100%;display: flex;flex-flow:column nowrap;justify-content:center;align-items:center;"
        >
          <GStockLoader :loading="loading" />
          <h4 style="width:100%;">Choisir un mois</h4>
          <month-picker @change="showDate"></month-picker>
          <b-button @click="exportData" style="margin-top:25px;"
            >Exporter en format Excel</b-button
          >
          <div ref="excelDownload" v-if="ready">
            <json-excel :data="dataForExcel" v-show="false" ref="excelDwnl" />
          </div>
        </div>
      </b-modal>
    </div>
    <b-container fluid>
      <b>Filtrer :</b>
      <b-row class="my-1">
        <b-col sm="3">
          <label :for="`type-productid`">
            Par
            <code>Référence du produit</code>:
          </label>
        </b-col>
        <b-col sm="9">
          <form v-on:submit.prevent="filterByRef">
            <base-input
              alternative
              placeholder="Référence du produit"
              input-classes="form-control-alternative"
              v-model="ref"
            />
          </form>
        </b-col>
      </b-row>
      <b-row class="my-1" v-for="type in types" :key="type.id">
        <b-col sm="3">
          <label :for="`type-${type.id}`">
            Par
            <code>{{ type.text }}</code
            >:
          </label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            :id="`type-${type.id}`"
            :type="type.type"
            :placeholder="type.placeholder"
            v-model="filter[type.filterField]"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="3">
          <label :for="`type-3`">
            Par
            <code>client</code>:
          </label>
        </b-col>
        <b-col sm="9">
          <b-form-select
            id="type-3"
            v-model="filter.clientId"
            :options="options"
          ></b-form-select>
        </b-col>
      </b-row>
      <div>
        <b-button size="lg" variant="primary" @click="filterData()"
          >Filter</b-button
        >
        <b-button size="lg" @click="clearFilter()">Effacer le filtre</b-button>
      </div>
    </b-container>
    <br />
    <div class="table-container">
      <b-table
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        striped
        responsive="sm md"
      >
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click="deleteItem(row.item)" class="mr-2"
            >Supprimer</b-button
          >
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
    <ProductDetails :product="currentProduct" ref="details" />
  </div>
</template>
<script>
import { setToken, post, get, del } from "@/mixins/api";
import ProductDetails from "./Historique/ProductDetails";
import CommonHeader from "@/components/CommonHeader";
import { MonthPicker } from "vue-month-picker";
import JsonExcel from "vue-json-excel";
import GStockLoader from "@/components/Loader";

export default {
  name: "payments",
  components: {
    ProductDetails,
    CommonHeader,
    MonthPicker,
    JsonExcel,
    GStockLoader,
  },

  data() {
    return {
      ready: false,
      loading: false,
      dataForExcel: [
        { colA: "Hello", colB: "World" },
        {
          colA: "Multi-line",
          /* Multi-line value: */
          colB:
            "This is a long paragraph\nwith multiple lines\nthat should show in a single cell.",
        },
        { colA: "Another", colB: "Regular cell" },
      ],
      date: {
        from: null,
        to: null,
        month: null,
        year: null,
      },
      types: [
        {
          id: 1,
          type: "text",
          filterField: "productName",
          text: "Nom de l'article",
          placeholder: "Nom de l'article",
        },
        {
          id: 2,
          type: "date",
          filterField: "from",
          text: "Date : De",
        },
        {
          id: 3,
          type: "date",
          filterField: "to",
          text: "Date : Jusqu'à",
        },
      ],
      filter: {
        from: null,
        to: null,
        clientId: null,
        productName: null,
      },
      perPage: 20,
      currentPage: 1,
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "réf", sortable: true },
        { key: "déposant", sortable: true },
        { key: "article", sortable: true },
        { key: "prix", sortable: true },
        { key: "commission", sortable: true },
        { key: 'tva', sortable: true},
        { key: "en_main", sortable: true },
        { key: "date", sortable: true },
        { key: "statut", sortable: true },
        { key: "actions", sortable: true },
      ],
      data: {
        result: [],
        count: 0,
      },
      standAlonePages: {},
      canLoadMore: true,
      clients: [],
      userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU4MDU4NjAyNSwiZXhwIjoxNjEyMTIyMDI1fQ.S-1D-cyFnF01yV5eUocskHpDThfK5fkMxuRC34Y_8nY",
      filtering: false,
      loadedProducts: {},
      currentProduct: { client: {} },
      ref: "",
    };
  },
  watch: {
    currentPage: {
      handler: function(newVal) {
        if (Object.keys(this.standAlonePages).some((page) => page == newVal)) {
          this.data = this.standAlonePages[newVal];
        } else {
          if (this.filtering)
            this.loadData(
              this.filter.clientId == "" ? null : this.filter.clientId,
              this.filter.productName == "" ? null : this.filter.productName,
              this.filter.from,
              this.filter.to
            );
          else this.loadData();
        }
      },
    },
  },
  filters: {
    date: function(value) {
      if (!value) return "";
      const date = new Date(value);
      const tmp = date.toLocaleDateString("fr-FR", { weekday: "long" });
      const day = tmp.charAt(0).toUpperCase() + tmp.slice(1);
      const month = date.toLocaleString("fr-FR", { month: "long" });
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      let currentHour = date.getHours() + "";
      let currentMinute = date.getMinutes() + "";
      if (currentHour.length < 2) currentHour = "0" + currentHour;
      if (currentMinute.length < 2) currentMinute = "0" + currentMinute;
      return (
        day +
        " " +
        dayOfMonth +
        " " +
        month +
        " " +
        year +
        ", " +
        currentHour +
        ":" +
        currentMinute
      );
    },
  },
  computed: {
    items() {
      return this.data.result.reduce(
        (acc, item) => [
          ...acc,
          {
            id: item.id,
            article: item.product.name,
            prix: item.price.toFixed(2) + "DT",
            commission: item.revenue.toFixed(2) + "DT",
            tva: (item.revenue * 0.19).toFixed(2) + "DT",
            en_main:
              (item.product.price * (1 - item.product.percentage)).toFixed(2) +
              "DT",
            réf: item.product.id,
            date: this.$options.filters.date(item.createdOn),
            déposant: (
              this.clients.find((it) => it.id == item.product.owner) || {
                fullname: "",
              }
            ).fullname,
            statut:
              item.acheteur == item.product.owner
                ? "Annulé"
                : item.product.paid != 1
                ? "Vendu"
                : "Vendu payé",
            actions: "",
            _rowVariant:
              item.product.canceled == 1
                ? "customORed"
                : item.product.paid == 1
                ? "customGreen"
                : item.product.purchased == 1 &&
                  item.product.canceled != 1 &&
                  item.product.paid != 1
                ? "customOrange"
                : "",
          },
        ],
        []
      );
    },
    options() {
      const defaultItem = {
        text: "Choisir un client",
        value: null,
      };
      return this.clients.reduce(
        (acc, item) => [...acc, { text: item.fullname, value: item.id }],
        [defaultItem]
      );
    },
    rows() {
      return this.data.count;
    },
  },
  methods: {
    loadData(
      clientId = null,
      productName = null,
      from = null,
      to = null,
      productId = null
    ) {
      const top = this.perPage;
      post(`getPaidPurchases/${top}/${(parseInt(this.currentPage) - 1) * top}`, {
        clientId,
        productName,
        from,
        to,
        productId,
      }).then((resp) => {
        this.standAlonePages[this.currentPage] = resp.data.data;
        this.data = resp.data.data;
        this.canLoadMore = resp.data.canLoadMore;
      });
    },
    loadClients() {
      get("clients")
        .then((data) => {
          this.clients = data.data.data || [];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filterByRef() {
      if (this.ref.indexOf(")") > 0) {
        this.ref = this.ref.substring(1, this.ref.indexOf(")"));
      }
      this.filtering = true;
      this.standAlonePages = {};
      this.loadData(null, null, null, null, this.ref);
    },
    filterData() {
      this.filtering = true;
      this.standAlonePages = {};
      this.ref = "";
      this.loadData(
        this.filter.clientId == "" ? null : this.filter.clientId,
        this.filter.productName == "" ? null : this.filter.productName,
        this.filter.from,
        this.filter.to
      );
    },
    clearFilter() {
      this.filtering = false;
      this.filter = {
        from: null,
        to: null,
        clientId: null,
        productName: null,
      };
      this.loadData();
    },
    deleteItem(item) {
      this.$bvModal
        .msgBoxConfirm(
          "etes-vous sur de bien vouloir supprimer cette ligne ?",
          {
            title: "Confirmez SVP!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NON",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            del("purchase/" + item.id).then((data) => {
              this.currentPage = 1;
              this.loadData();
            });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    showDate(date) {
      this.date = date;
    },
    exportData() {
      // console.log(this.date);
      this.loading = true;
      post("getExcel", {
        from: this.date.from,
        to: this.date.to,
      })
        .then((data) => {
          console.log(data)
          this.dataForExcel = data.data.data;
          this.ready = true;
          const self = this
          setTimeout(() => {
            self.loading = true;
            self.$refs.excelDwnl.generate();
            self.$refs.modalExcel.hide();
          }, 2000);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    setToken(this.userToken);
    this.loadData();
    this.loadClients();
  },
};
</script>
<style lang="scss">
.historique {
  .btn-primary {
    background-color: #000;
    border-color: #000;
  }
  .page-item {
    &.active {
      .page-link {
        background-color: #000;
        border-color: #000;
      }
    }
  }
  // margin-top: 150px;
  // .table-container {
  //   display: flex;
  //   flex-flow: column nowrap;
  //   justify-content: center;
  //   align-items: center;
  // }
}
</style>
